<template>
  <g class="axis" :class="classes" :transform="transform" :style="style"></g>
</template>

<script>
import * as axis from 'd3-axis'
import { select } from 'd3-selection'

export default {
  name: 'Axis',
  props: {
    orientation: {
      type: String,
      default: 'bottom'
    },
    scale: {
      type: Function,
      default () {
        return function () {}
      }
    },
    ticks: {
      type: Number,
      default: 5
    },
    offsetX: {
      type: Number,
      default: 0
    },
    offsetY: {
      type: Number,
      default: 0
    },
    tickSizeInner: {
      type: [Number],
      default: 6
    },
    tickFormat: Function,
    opacity: {
      type: Number,
      default: 1
    },
    paddedIndex: Boolean
  },
  computed: {
    self () {
      return this.axis
    },
    el () {
      return select(this.$el)
    },
    type () {
      return 'axis' + this.orientation.charAt(0).toUpperCase() + this.orientation.slice(1).toLowerCase()
    },
    classes () {
      return `axis-${this.orientation}`
    },
    style () {
      return {
        opacity: this.opacity
      }
    },
    transform () {
      return `translate(${this.offsetX}, ${this.offsetY})`
    }
  },
  watch: {
    'ticks': 'draw',
    'scale': 'draw',
    'tickSizeInner': 'draw'
  },
  methods: {
    draw () {
      this.axis = axis[this.type](this.scale)
      this.axis.ticks(this.ticks)
      this.axis.tickSizeInner(this.tickSizeInner)
      if (this.paddedIndex) this.axis.tickFormat(d => d + 1)

      this.el.call(this.axis)
    }
  },
  ready () {
    this.draw()
  }
}
</script>

<style lang="scss">
.tick {
  &:nth-child(19) {
    line {
      stroke: blue;
      stroke-width: 4;
    }
  }
}
</style>


// WEBPACK FOOTER //
// Axis.vue?57cc1c8d